import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { AccreditionsRoutingModule } from './accreditions-routing.module';
import { AccreditionsListComponent } from './accreditions-list/accreditions-list.component';
import { AccreditionsCreateComponent } from './accreditions-create/accreditions-create.component';

import { ReactiveFormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { Ng2SmartTableModule } from 'ng2-smart-table';

@NgModule({
  declarations: [AccreditionsListComponent, AccreditionsCreateComponent],
  imports: [
    CommonModule,
    AccreditionsRoutingModule,
    ReactiveFormsModule,
    NgbModule,
    Ng2SmartTableModule
  ]
})
export class AccreditionsModule { }
